(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ContactUsControllerPrivacy', ContactUsControllerPrivacy);

    ContactUsControllerPrivacy.$inject = ['$state', 'User'];

    function ContactUsControllerPrivacy($state, User) {
        var vm = this;

        vm.form = true;
        vm.contact = [];

        vm.contactUs = function (){

            var body = {
                email: vm.contact.email,
                name: vm.contact.name,
                message: vm.contact.message
            };

            User.sendPrivacyMail(body, onSuccess, onError);

            function onSuccess(){
                vm.form = false;
            }

            function onError(){}
        };
    }
})();
